import React from 'react';
import styles from './ProgressBar.module.sass'
export const ProgressBar = ({ percentage}) => {
    return (
        <div className={styles.progressBar}>
            <div className={styles.filler} style={{ width: `${percentage}%` }}></div>
        </div>
    );
};
